import React, { useEffect, useState } from 'react';
import { Order } from '../../types/orderTypes';
import './Deviation.scss';

export function WarningDeviation({ order }: { order: Order }): JSX.Element {
  const [deviationStatus, setDeviationStatus] = useState('CLOSED');
  const [courierDeviationStatus, setCourierDeviationStatus] =
    useState('CLOSED');

  const lastObjectInArray = (array = []) => array[array.length - 1];

  useEffect(() => {
    if (!order) return;
    const { deviations, openCourierDeviation } = order;

    if (deviations && deviations.length) {
      const status = lastObjectInArray(deviations).deviationStatus;
      setDeviationStatus(status);
    }

    if (openCourierDeviation)
      setCourierDeviationStatus(openCourierDeviation ? 'OPEN' : 'CLOSED');
  }, [order]);

  if (deviationStatus === 'OPEN' || courierDeviationStatus === 'OPEN') {
    const warningText = (deviationType: string) =>
      `WARNING, this order is registered as an open ${deviationType} deviation`;

    return (
      <>
        <div className="InfoBanner">
          <div className="warning">&#9888;</div>
          <span className="bannerBoxText">
            {deviationStatus === 'OPEN' && warningText('partner')}
          </span>
          <span className="bannerBoxText">
            {courierDeviationStatus === 'OPEN' && warningText('courier')}
          </span>
        </div>
      </>
    );
  }

  return <div />;
}
